import { useDispatch } from 'react-redux';
import { useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { isEmptyArr } from '@utils/helper';
import { useInfiniteQuery } from 'react-query';

import { removeObjEmptyValues } from '../helpers';
import { OfferFlatType } from '../models';
import { setCreateOrUpdateTotalElements } from '../store';

export function useFlats() {
  const dispatch = useDispatch();
  const { id, filter, visible } = useAppSelector(({ offerReducer: { createOrUpdate } }) => createOrUpdate);

  // remove all empty values
  const parsePayload = removeObjEmptyValues(filter);

  // generate body payload
  const payload = {
    ...parsePayload,
    buildings: (parsePayload as { buildings: string[] })?.buildings
      ? (parsePayload as { buildings: string[] })?.buildings?.map(i => JSON.parse(i)?.id)
      : undefined
  };

  const { data, ...arg } = useInfiniteQuery<
    {
      totalPages: number;
      currentPage: number;
      totalElements: number;
      flats: OfferFlatType[];
    },
    OfferFlatType
  >(
    ['offer-flats', filter],
    async ({ pageParam = 1 }) => {
      const { data } = await $api.post(id ? `/v1/flat/offer?offerId=${id}` : '/v1/flat/offer/filter', {
        ...payload,
        page: pageParam,
        size: 50
      });

      return { ...data?.data, flats: data?.data?.data };
    },
    {
      retry: false,
      getNextPageParam: (lastPage, page) => {
        if (page.length < lastPage?.totalPages) {
          return page.length + 1;
        }

        return undefined;
      },
      enabled: (!isEmptyArr(filter?.houses) || !isEmptyArr(filter?.buildings)) && visible
    }
  );

  dispatch(setCreateOrUpdateTotalElements(data?.pages?.[0]?.totalElements || 0));

  return {
    totalPages: data?.pages?.[0]?.totalPages || 0,
    currentPage: data?.pages?.[(data?.pages?.length || 1) - 1]?.currentPage || 1,

    // get flats from all pages
    flats: data?.pages
      .flat()
      ?.map(({ flats }) => flats)
      ?.flat(),
    ...arg
  };
}
